import { render, staticRenderFns } from "./StoryForm.vue?vue&type=template&id=766b5bbb"
import script from "./StoryForm.vue?vue&type=script&lang=ts"
export * from "./StoryForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports